import { TaxonomyActions } from "../reducerActions/TaxonomyActions";

const initialState = {
    loadingLanguages:false,
    loadingStates:false,
    languages:undefined,
    states:undefined,
}

const TaxonomyReducer = (state=initialState,action) => {

    const newState ={...state};

    if(action.type === TaxonomyActions.SAVE_LANGUAGES){
        newState.languages = action.languages;
        newState.loadingLanguages = false;
    }

    else if(action.type === TaxonomyActions.SAVE_STATES){
        newState.states = action.states;
        newState.loadingStates = false;
    }

    return newState;
}

export default TaxonomyReducer;